import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { authApi } from "../lib/api/auth.js";
import { useAuth } from "../lib/auth-context.js";
import "./Login.css";

/** Magic-link destination: POST the token, open the session, then route into the app.
 *  A SPA page (not a bare GET) so email scanners can't silently burn the one-time token. */
export function EmailVerify() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // guard StrictMode's double-invoke from burning the token twice
    ran.current = true;
    if (!token) {
      setError("This sign-in link is missing or malformed.");
      return;
    }
    void (async () => {
      const res = await authApi.verifyEmailLink(token);
      if (!res.success) {
        setError(res.error ?? "This sign-in link is invalid or has expired.");
        return;
      }
      await refresh();
      navigate(res.data?.isNew ? "/onboarding" : "/app", { replace: true });
    })();
  }, [token, refresh, navigate]);

  return (
    <main className="login">
      <div className="login__card">
        <Link to="/" className="brand brand--ink login__brand">
          <img src="/tatu.svg" alt="" aria-hidden="true" width={32} height={32} />
          Ondetatu
        </Link>
        {error ? (
          <>
            <h1 className="login__title">Couldn't sign you in</h1>
            <p className="login__sub">{error}</p>
            <Link className="btn btn-primary" to="/login">
              Back to sign in
            </Link>
          </>
        ) : (
          <output className="login__sub login__signing">Signing you in…</output>
        )}
      </div>
    </main>
  );
}
